import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function productDescriptionSelectedValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const obj = control.value;
    if (
      typeof obj === 'object' &&
      obj !== null &&
      typeof obj.name === 'string' &&
      obj.name.trim().length > 0 &&
      (typeof obj.productId === 'string' || typeof obj.productId === 'number') &&
      String(obj.productId).trim().length > 0
    ) {
      return null;
    }
    return { productDescriptionNotSelected: true };
  };
}
